define('tavanoteamstaging_madetoorder_pdp.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('tavanoteamstaging_madetoorder_pdp', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div></div>";
},"useData":true}, 'extensions/TavanoTeamStaging/MadeToOrder/1.0.0/', 'extensions/TavanoTeamStaging/MadeToOrder/1.0.0/', Handlebars);
});